import { Link } from 'react-router-dom';

// Placeholder pras rotas listadas na Sidebar mas que serao implementadas
// nas Fases 3-5. Permite navegacao sem erro de Router.
export default function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center">
      <p className="text-xs uppercase tracking-widest text-primary font-semibold mb-2">
        Em construção
      </p>
      <h1 className="text-2xl font-bold text-text-strong mb-2">Página ainda não implementada</h1>
      <p className="text-sm text-text-muted max-w-md mb-6">
        Esta rota faz parte do plano e será entregue em fase posterior. Por enquanto a Fase 2
        cobriu apenas a infra e os componentes reutilizáveis.
      </p>
      <Link
        to="/"
        className="text-sm text-primary hover:text-primary-hover font-medium underline-offset-4 hover:underline"
      >
        Voltar para o dashboard
      </Link>
    </div>
  );
}
